import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plans-page" }
const _hoisted_2 = { class: "plans-header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "header-subtitle" }
const _hoisted_5 = { class: "header-frequency" }
const _hoisted_6 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_7 = {
  key: 1,
  class: "plans-container"
}
const _hoisted_8 = {
  key: 0,
  class: "featured-badge"
}
const _hoisted_9 = { class: "plan-content" }
const _hoisted_10 = { class: "plan-top" }
const _hoisted_11 = { class: "plan-name" }
const _hoisted_12 = { class: "plan-description" }
const _hoisted_13 = { class: "plan-price" }
const _hoisted_14 = { class: "currency" }
const _hoisted_15 = { class: "amount" }
const _hoisted_16 = { class: "price-description" }
const _hoisted_17 = { class: "plan-features" }
const _hoisted_18 = { class: "description" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "plan-footer" }
const _hoisted_21 = ["onClick"]

import store from "@/store";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { toast } from "@/common/utils/toast";

import { planList } from "@/common/api/rest/plan";
import { userAccountByMember } from "@/common/api/rest/user";

import type { PlanType } from "@/common/types/plan/plan";
import type { PlanPriceType } from "@/common/types/plan/price";

import { DefaultTheme } from "@/common/themes";
import { baseSelect, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const account = ref<any>(null);
const plans = ref<PlanType[]>([]);
const isLoading = ref(false);
const frequency = ref("MONTHLY");

const featuredPlan = ref("6a93450233dbe0acac0d7a8b");

const frequencyOptions = computed(() => [
  { option: "Mensal", value: "MONTHLY" },
  // { option: "Semestral", value: "SEMESTER" },
  { option: "Anual", value: "YEARLY" },
]);

const currencyOptions = computed(() => ({
  BRL: "R$",
  USD: "$",
  EUR: "€",
}));

async function fecthAccount() {
  await userAccountByMember(store.getters.user?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        account.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchPlans() {
  try {
    isLoading.value = true;
    const accountId = account.value?.account_id;
    if (!accountId) {
      toast({ message: t("error.no_account"), type: "error" });
      return;
    }

    const response = await planList(accountId);
    if (response.success) {
      plans.value = response.data.list;
    } else {
      toast({ message: response.message, type: "error" });
    }
  } catch (error) {
    toast({ message: t("error.default"), type: "error" });
  } finally {
    isLoading.value = false;
  }
}

function selectPlan(plan: PlanType) {
  router.push(`/checkout/${plan.plan_id}?frequency=${frequency.value}`);
}

function getCurrency(plan: PlanType) {
  const price = plan.prices.find((item) => item.frequency === frequency.value);

  if (price) {
    return currencyOptions.value[price.currency];
  }

  return " -- ";
}

function getPrice(plan: PlanType) {
  const price = plan.prices.find((item) => item.frequency === frequency.value);

  if (price) {
    return (price.price / 100).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return " -- ";
}

function getDescription(plan: PlanType) {
  const price = plan.prices.find((item) => item.frequency === frequency.value);

  if (price) {
    return price.description;
  }

  return " -- ";
}

onMounted(async () => {
  await fecthAccount();
  if (account.value) {
    fetchPlans();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DefaultTheme), {
    "menu-active": "plans",
    "account-status": account.value?.status
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("plan.texts.choose_plan")), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("plan.texts.subtitle")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(baseSelect), {
              modelValue: frequency.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((frequency).value = $event)),
              value: frequency.value,
              options: frequencyOptions.value,
              "is-empty": false
            }, null, 8, ["modelValue", "value", "options"])
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "spinner" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(t)("common.loading")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, (plan) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: plan.plan_id,
                  class: _normalizeClass(["plan-card", { 'is-featured': plan.plan_id === featuredPlan.value }])
                }, [
                  (plan.plan_id === featuredPlan.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("plan.labels.most_popular")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(plan.name), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(plan.description || "O plano ideal para você."), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(getCurrency(plan)), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(getPrice(plan)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(getDescription(plan)), 1)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "plan-divider" }, null, -1)),
                    _createElementVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.modules, (mod) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: mod.module_id
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "confirmed",
                            size: "1.2rem"
                          }),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("strong", null, _toDisplayString(mod.name), 1),
                            _createElementVNode("span", {
                              innerHTML: mod.description
                            }, null, 8, _hoisted_19)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "subscribe-btn",
                      onClick: ($event: any) => (selectPlan(plan))
                    }, " Comece Agora ", 8, _hoisted_21)
                  ])
                ], 2))
              }), 128))
            ]))
      ])
    ]),
    _: 1
  }, 8, ["account-status"]))
}
}

})